export default "__VITE_ASSET__ICeuq0h4__"